var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91016 14.5H2.6875C1.48129 14.5 0.5 13.5187 0.5 12.3125V4.90234C0.5 3.69613 1.48129 2.71484 2.6875 2.71484H7.91016C9.11637 2.71484 10.0977 3.69613 10.0977 4.90234V12.3125C10.0977 13.5187 9.11637 14.5 7.91016 14.5ZM2.6875 3.80859C2.08443 3.80859 1.59375 4.29928 1.59375 4.90234V12.3125C1.59375 12.9156 2.08443 13.4062 2.6875 13.4062H7.91016C8.51322 13.4062 9.00391 12.9156 9.00391 12.3125V4.90234C9.00391 4.29928 8.51322 3.80859 7.91016 3.80859H2.6875ZM12.2852 10.9453V2.6875C12.2852 1.48129 11.3039 0.5 10.0977 0.5H4.02734C3.72528 0.5 3.48047 0.744809 3.48047 1.04688C3.48047 1.34894 3.72528 1.59375 4.02734 1.59375H10.0977C10.7007 1.59375 11.1914 2.08443 11.1914 2.6875V10.9453C11.1914 11.2474 11.4362 11.4922 11.7383 11.4922C12.0403 11.4922 12.2852 11.2474 12.2852 10.9453Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.28cb07042d48e1182576341be33c7456.svg";
export { ForwardRef as ReactComponent };